import React from 'react'
import { Route, Redirect, } from 'react-router-dom'
import { isAuthenticated } from '../utils/auth'

const BasicRouter = ({component: Component, ...rest}) => (
  <Route {...rest} render={(props) => (
    isAuthenticated()
      ? <Component {...props} />
      : <Redirect to={{   //重定向
        pathname: '/login',
        state: {from: props.location}
      }}/>
  )}/>
)

export default BasicRouter